import orderConfig from '@/modules/order/config'
import purchaseConfig from '@/modules/purchase/config'
import store from 'redux/store'
import deliveryNoteConfig from '@/modules/deliveryNote/config'
import letterConfig from '@/modules/transactionLetter/config'
import offerConfig from '@/modules/offer/config'
import invoiceConfig from '@/modules/invoice/config'
import { printByPdfUrl } from '@/modules/_helpers/printByPdfUrl'
import { printAndCombineByPdfUrl } from '@/modules/_helpers/printAndCombineByPdfUrl'
import config from '@/config'
import { transactionTypes } from '@/modules/base/util/constants'
import { stopPrinting } from '.'

const {
  TRANSACTION_TYPE_INVOICE,
  TRANSACTION_TYPE_CANCELLATION,
  TRANSACTION_TYPE_CREDIT_NOTE,
  TRANSACTION_TYPE_DEPOSIT_INVOICE,
  TRANSACTION_TYPE_RECURRING_INVOICE,
  TRANSACTION_TYPE_CLOSING_INVOICE,
  TRANSACTION_TYPE_OFFER,
  TRANSACTION_TYPE_ORDER,
  TRANSACTION_TYPE_DELIVERY_NOTE,
  TRANSACTION_TYPE_CASH_INVOICE,
  TRANSACTION_TYPE_CASH_CANCELLATION,
  TRANSACTION_TYPE_CASH_CREDIT_NOTE,
  TRANSACTION_TYPE_SHOPIFY_CASH_INVOICE,
  TRANSACTION_TYPE_SHOPIFY_CASH_CANCELLATION,
  TRANSACTION_TYPE_SHOPIFY_CASH_CREDIT_NOTE,
  TRANSACTION_TYPE_SHOPIFY_CASH_ORDER,
  TRANSACTION_TYPE_REFUND_INVOICE,
  TRANSACTION_TYPE_REFUND_ORDER,
  TRANSACTION_TYPE_MANUAL_CREDIT_NOTE,
  TRANSACTION_TYPE_LETTER,
  TRANSACTION_TYPE_PURCHASE,
} = transactionTypes

export const printSelection = (listSettingName, modelType, selectedNodes) => {

  let baseURL
  const filesToPrint = []

  if (selectedNodes.length > 1) {
    selectedNodes.map((node) => {
      const { data } = node
      const { id, type } = data

      filesToPrint.push(
        {
          type: type || modelType,
          id,
        },
      )
    })

    baseURL = `${config.transactionResourceURL}/documentCollection`

    printAndCombineByPdfUrl(baseURL, filesToPrint, (response) => {
      store.dispatch(stopPrinting(listSettingName))
    })
  } else {
    const { data } = selectedNodes[0]
    const { id, type } = data
    const currentType = type || modelType

    switch (currentType) {
      case TRANSACTION_TYPE_OFFER:
        baseURL = `${offerConfig.resourceUrl}/${id}/document`
        break
      case TRANSACTION_TYPE_ORDER:
      case TRANSACTION_TYPE_SHOPIFY_CASH_ORDER:
      case TRANSACTION_TYPE_REFUND_ORDER:
        baseURL = `${orderConfig.resourceUrl}/${id}/document`
        break
      case TRANSACTION_TYPE_DELIVERY_NOTE:
        baseURL = `${deliveryNoteConfig.resourceUrl}/${id}/document`
        break
      case TRANSACTION_TYPE_LETTER:
        baseURL = `${letterConfig.resourceUrl}/${id}/document`
        break
      case TRANSACTION_TYPE_PURCHASE:
        baseURL = `${purchaseConfig.resourceUrl}/${id}/document`
        break
      case TRANSACTION_TYPE_INVOICE:
      case TRANSACTION_TYPE_DEPOSIT_INVOICE:
      case TRANSACTION_TYPE_RECURRING_INVOICE:
      case TRANSACTION_TYPE_CLOSING_INVOICE:
      case TRANSACTION_TYPE_SHOPIFY_CASH_INVOICE:
      case TRANSACTION_TYPE_CASH_INVOICE:
      case TRANSACTION_TYPE_MANUAL_CREDIT_NOTE:
      case TRANSACTION_TYPE_REFUND_INVOICE:
        baseURL = `${config.resourceHost}${TRANSACTION_TYPE_INVOICE}/${id}/document`
        break
      case TRANSACTION_TYPE_CREDIT_NOTE:
      case TRANSACTION_TYPE_CASH_CREDIT_NOTE:
      case TRANSACTION_TYPE_SHOPIFY_CASH_CREDIT_NOTE:
      case TRANSACTION_TYPE_CANCELLATION:
      case TRANSACTION_TYPE_SHOPIFY_CASH_CANCELLATION:
      case TRANSACTION_TYPE_CASH_CANCELLATION:
        baseURL = `${invoiceConfig.cancellationUrl}/${id}/document`
        break
    }

    printByPdfUrl(baseURL, (response) => {
      store.dispatch(stopPrinting(listSettingName))
    })
  }
}
